/**
 *
 * Asynchronously loads the component for DiscWithGuides
 *
 */

import { lazyLoad } from 'utils/loadable';

export const DiscWithGuides = lazyLoad(
  () => import('./index'),
  module => module.DiscWithGuides,
);
